import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { StoreState } from '../../reducers';
import Page from '../../containers/Page';
import { PageType } from '../../containers/Page/constants';
import Toggle from '../Toggle';
import Table from '../../containers/NotesPage/Table';
import { getNotes, resetNotes, setNotesStatus } from '../../containers/NotesPage/actions';
import { NotesStatus, LoadingStatus } from '../../containers/NotesPage/reducer';
import { TableWrapper, Loader } from './styles';
import Utils from '../../utils';

interface NotesPageProps {
	notesStatus: NotesStatus;
	loadingStatus: LoadingStatus;
	dispatch: Dispatch<StoreState>;
}

const notesStatusConfig = {
	[NotesStatus.LOCAL]: {
		id: NotesStatus.LOCAL,
		label: 'messages.local',
	},
	[NotesStatus.SHARED]: {
		id: NotesStatus.SHARED,
		label: 'messages.shared',
	},
};

const NotesPage = ({ notesStatus, loadingStatus, dispatch }: NotesPageProps) => {
	const tableContainer = React.useRef<HTMLDivElement>(null);

	React.useEffect(() => {
		dispatch(getNotes());

		return () => {
			dispatch(resetNotes());
		};
	}, []);

	React.useEffect(() => {
		if (tableContainer.current) {
			tableContainer.current.scrollTop = 0;
		}
	}, [notesStatus]);

	const isLoading = [LoadingStatus.LOADING, LoadingStatus.SAVING].includes(loadingStatus);
	const loaderMessage = loadingStatus === LoadingStatus.SAVING
		? 'messages.saving'
		: 'messages.loading';

	return (
		<Page
			pageType={PageType.NotesPage}
			title="messages.my_notes"
		>
			{isLoading &&
				<Loader className="NotesPageLoader">
					{Utils.getSvgIcon('iconset_loading')}
					<Translate value={loaderMessage} />
				</Loader>
			}
			<Toggle
				items={Object.values(notesStatusConfig)}
				activeId={notesStatus}
				onItemClick={(status) => dispatch(setNotesStatus(status as NotesStatus))}
				width="110px"
			/>
			<TableWrapper className="NotesPageTableWrapper" ref={tableContainer}>
				<Table />
			</TableWrapper>
		</Page>
	);
};

export default NotesPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NotesPage/index.tsx